export default "__VITE_ASSET__R_Nv_uAo__"